// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { BaseConnectionOperation } from './base-connection-operation';
import { IOperation } from '@shared/undo/operation/i-operation';
import { ProjectModel } from '@project/model/project.model';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { ConnectionConverter } from '@article/components/connections/connection-creation/connection-converter';
import { ConnectionCreator } from '@article/components/connections/connection-creation/connection-creator';
import { ProjectArticleManager } from '@project/components/article/manager/project-article.manager';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { AdminService } from '../services/admin.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';

export class ChangeConnectionOrderNumberOperation extends BaseConnectionOperation implements IOperation {
  constructor(
    connection: Connection,
    articleContainer: ArticleContainer,
    article: ArticleVO,
    private _oldOrderNumber: number,
    private _newOrderNumber: number,
    adminService: AdminService,
    projectModel: ProjectModel,
    selectionModel: SelectionModel,
    selectionModelService: SelectionModelService,
    sceneManager: SceneManager,
    projectArticleManager: ProjectArticleManager,
    connectionCreator: ConnectionCreator,
    connectionConverter: ConnectionConverter,
    applicationRefreshService: ApplicationRefreshService,
    connections?: Connection[]
  ) {
    super(
      adminService,
      projectModel,
      selectionModel,
      selectionModelService,
      sceneManager,
      projectArticleManager,
      connectionCreator,
      connectionConverter,
      connection,
      articleContainer,
      article,
      applicationRefreshService,
      connections
    );
  }

  public getQualifiedClassName(): string {
    return 'ChangeConnectionOrderNumberOperation';
  }

  public getOperationDescription(): string {
    return 'changeConnectionOrderNumberOperation.description';
  }

  public async performRedo(): Promise<void> {
      this.changeConnectionOrderNumber(this._newOrderNumber);
  }

  public async performUndo(): Promise<void> {
      this.changeConnectionOrderNumber(this._oldOrderNumber);
  }
}
